<template>
  <div class="main">
    <sidebar
      v-if="isMobile"
      :open="sidebarOpen"
      @toggle="toggleSidebar"
    >
      <b-nav vertical id="sidebar-navbar">
        <b-input-group id="sidebar-search">
          <b-form-input v-model="search" @keyup.enter="onSearch" placeholder="상품 검색..."></b-form-input>
          <b-input-group-append>
            <b-button @click="search" class="nav-button" variant="warning"><b-icon-search class="nav-icon" /></b-button>
          </b-input-group-append>
        </b-input-group>
        <b-nav-item @click="toggleSidebar" to="/">HOME</b-nav-item>
        <b-nav-item @click="toggleSidebar" to="/items">종류별 순위</b-nav-item>
        <b-nav-item @click="toggleSidebar" to="/nutri">성분별 순위</b-nav-item>
        <b-nav-item @click="toggleSidebar" to="/about">About</b-nav-item>
      </b-nav>
    </sidebar>
    <b-navbar id="title" fixed='top'>
      <b-button v-if="isMobile" class='button-list' @click="toggleSidebar"><b-icon-list /></b-button>
      <b-nav-item href="/"><span class="bi-logo">pricewagon</span></b-nav-item>
      <span class='bi-sub' >영양제 성분/가격 정보</span>

      <b-input-group class="search-form" v-if="!isMobile">
        <b-form-input @keyup.enter="onSearch" v-model="search" placeholder="상품 검색..."></b-form-input>
        <b-input-group-append>
          <b-button @click="onSearch" v-on:keyup.enter="onSearch" class="nav-button" variant="warning"><b-icon-search class="nav-icon" /></b-button>
        </b-input-group-append>
      </b-input-group>

      <div class="nav-items align-right" v-if="!isMobile">
        <b-nav-item to="/">HOME</b-nav-item>
        <b-nav-item to="/items">종류별 순위</b-nav-item>
        <b-nav-item to="/nutri">성분별 순위</b-nav-item>
        <b-nav-item to="/about">About</b-nav-item>
      </div>
    </b-navbar>
    <div id="content">
      <router-view></router-view>
    </div>
    <div id="footer">
      <div class="footer-inner">
        <p>프라이스 웨건</p>
        <p>문의사항: <a href="mailto:agile.data.service@gmail.com">agile.data.service@gmail.com</a></p>
        <p>이메일로 상품 등록 요청이나 건의사항을 받습니다</p>
        
      </div>
      <div class="footer-inner">
        <b-nav-item href="https://mandu.pricewagon.net" exact exact-active-class="active">만두웨건</b-nav-item>
        <div id="naver-blog"><a href="https://blog.naver.com/pricewagon"><img src="static/naver-blog.png" /></a></div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '../util'
import Sidebar from './Sidebar'
import { mapGetters, mapState } from 'vuex'
import {
    BNav, BNavItem, BCard, BNavbar, BIconList, BFormInput, BIconHouse, BIconDash, BIconInfoCircle, BIconSearch
} from 'bootstrap-vue'
import { SidebarMenu } from 'vue-sidebar-menu'

export default {
  name: 'Main',
  components: {
    BNav, BNavItem, BCard, BIconList, BFormInput, BIconHouse, BIconSearch, BIconDash, BIconInfoCircle, SidebarMenu, Sidebar
  },
  data() {
    return {
      category_list: [],
      searchQuery: '',
      sidebarOpen: false
    }
  },
  created () {
  },
  computed: {
    search: {
      get() {
        return this.$store.state.filter.search
      },
      set(v) {
        this.searchQuery = v
      }
    },
    menu () {
      let menu = [{
        title: '영양제 종류별',
        hiddenOnCollapse: true
      }]
      menu[0].child = this.category_list
      return menu
    },
    isMobile () {
      return isMobile()
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    },
    collapse () {
      this.sidebarOpen = false
    },
    onSearch () {
      this.sidebarOpen = false
      if (this.$store.state.filter.search != this.searchQuery) {
        this.$router.push({path: `/search/${this.searchQuery}`}).catch(err => {})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.card-body {
  padding: 0;
}
.nav-link {
  padding: 0;
}
.bi-logo {
  color: #1E3E72;
  margin-right: 20px;
}
.bi-sub{
  font-size: 1rem;
  width: 100%;
}
.nav-items {
  width: 100%;
  /* text-align: right; */
  padding-right: 30px;
  font-size: 0.8rem;
  font-weight: 900;
}

#sidebar-search {
  margin-bottom: 20px;
  font-size: 1rem;
}

#sidebar-navbar > li {
  padding-bottom: 20px;
  margin-top: 20px;
  border-bottom: 1px solid #d9d9d9;
  font-size: 1.1rem;
  font-weight: 600;
}
#sidebar-navbar > li > a {
  color: #000;
}

.button-list {
  background: transparent;
  border: 0;
  color: #1E3E72;
}
.button-list > svg {
  margin: 0;
}
.footer-inner {
  vertical-align: top;
  display: inline-block;
  width: 400px;
}
.v-sidebar-menu {
  margin-top: 56px;
  background: #d9d9d9;
  /* border: 1px solid #d9d9d9; */
}
.v-sidebar-menu >>> .vsm--arrow_open {
  transform: translateY(-25%) rotate(90deg) !important;
}
.v-sidebar-menu >>> .vsm--link {
  font-size: 0.8rem;
}
#content {
  margin-top: 56px;
  min-height: calc(100vh - 56px);
}

#title {
  padding: 10px;
  background: #e9e9e9;
  color: #000;
  box-shadow: 0px 2px #d9d9d9;
}

#title >>> .bi-logo {
  font-weight: 700;
  font-size: 1.3rem;
}

#subtitle-navbar {
  position: fixed;
  background: transparent;
  text-align: right;
  min-width: 200px;
  width: 40vw;
  height: 51px;
  font-weight: 600;
  color: black;
  margin: 0;
  top: 0;
  right: 0;
  z-index: 1050;
  border: none;
}
.form-control{
  font-size: inherit;
}

.nav-icon, .nav-button {
  /* color: #fff; */
  font-size: inherit;
}
.nav-item > a > .nav-icon {
  margin-right: 10px;
}

.nav-button {
  width: 2.5rem;
}

.search-form {
  font-size: 0.8rem;
}

#footer {
  padding: 20px;
  color: white;
  background: black;
  font-size: 1rem;
}

#naver-blog {
  display: block;
}
#naver-blog >>> img {
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/Main.vue